module.exports = new __parcel__URL__("icons8-visual-studio-code.ccbc0c10.svg").toString();